// extracted by mini-css-extract-plugin
export default {"form":"EditarPedidoBmaAcesso_form__NRb8T","areaBtn":"EditarPedidoBmaAcesso_areaBtn__hGu7i","btn":"EditarPedidoBmaAcesso_btn__fNABl","btn2":"EditarPedidoBmaAcesso_btn2__Xk3LP"};